import React from 'react';
import { formLabelPropTypes } from '@App/common/components/FormLabel/FormLabelPropTypes';
import FormLabelCommon from '@App/common/components/FormLabel/FormLabel';
import * as styles from './FormLabel.module.scss';
const FormLabel = props => /*#__PURE__*/React.createElement(FormLabelCommon, Object.assign({}, props, {
  classname: `${styles.root} ${props.error ? styles.rootError : ''}`
}));
export default FormLabel;